// Importar todas las traducciones por idioma
import en from './en';
import es from './es';

// Exportar recursos para i18next
export const resources = {
  en,
  es
};

export default resources; 